/**
 * 
 * @author Jesus R. Nava Cruz
 * @date May 24, 2023
 * @version 1.0
 * 
 */

import ServiceConstant from "@/app/core/ServiceConstant";
import MainService from "@/app/services/MainService";

export default class LogService extends MainService {

    static listAllPagination(params) {
        return this.postSEC(ServiceConstant.LOG_LIST_ALL_PAGINATION, params);
    }

    static listAll() {
        return this.postSEC(ServiceConstant.LOG_LIST_ALL, params);
    }

    static get(params) {
        return this.postSEC(ServiceConstant.LOG_GET, params)
    }

    static add(params) {
        return this.postSEC(ServiceConstant.LOG_ADD, params);
    }

    static update(params) {
        return this.postSEC(ServiceConstant.LOG_UPDATE, params);
    }

    static delete(params) {
        return this.postSEC(ServiceConstant.LOG_DELETE, params);
    }
    
}
